 
 
 
 
 
 
define(['http', './utils', 'security', 'endpoints', './batchSearch'], function(http, utils,
    security, endpoints, batchSearch) {
    'use strict';

    var queryParamsNames = [
        'typeahead', 'limit', 'ofs', 'countrySet', 'lat', 'lon', 'language',
        'radius', 'topLeft', 'btmRight', 'idxSet', 'maxFuzzyLevel',
        'geometryList', 'extendedPostalCodesFor', 'maxDetourTime'
    ];

    return {
        search: function(options, callback) {
            var pathParams = {};
            var queryParams = {};
            var httpParams;

            // if an API key is specified, include it
            // an API key can be omitted if an API proxy is being used
            queryParams.key = utils.or(options.key, security.getKey('services/search'));

            // get required query statement
            pathParams.query = utils.required(options.query, 'Missing query statement in Search service');
            pathParams.type = utils.required(options.type, 'Missing type definition in Search service');

            // look for optional passed params and set them if they are not undefined
            utils.extractQueryParams(options, queryParams, queryParamsNames);

            httpParams = {
                url: '{protocol}://' + endpoints.search,
                pathParameters: pathParams,
                queryParameters: queryParams,
                callback: callback,
                callbackParam: 'callback',
                fail: options.fail
            };

            if (options.route) {
                // route for Search Along Route needs to be sent as POST param
                httpParams.bodyParameters = options.route;
            }

            switch (options.type) {
            case 'searchAlongRoute': {
                http.post(httpParams);
                break;
            }
            default: {
                http.get(httpParams);
                break;
            }
            }
        },
        batch: batchSearch(queryParamsNames)
    };
});



// WEBPACK FOOTER //
// ./rest/search.js